import { r as J, n as O, c as H, i as a, a as b, t as v, F as M, S as N, e as P, f as C, h as L, d as I } from "./__packages__deps__web-929faed1.js";
import { R as Q } from "./__packages__deps__Relations-f3162ea7.js";
import { c as V, q as z, g as T } from "./__packages__deps__queryProductByHandle-018098bd.js";
import { c as G } from "./__packages__deps__store-ec58bf2c.js";
const K = /* @__PURE__ */ v('<div class="!tw-typ-body-3"></div>'), U = /* @__PURE__ */ v("<h3></h3>"), W = /* @__PURE__ */ v("<span></span>"), X = /* @__PURE__ */ v('<span class="tw-mr-2 tw-text-border tw-line-through"></span>'), Y = /* @__PURE__ */ v("<span> </span>"), Z = /* @__PURE__ */ v('<div class="tw-flex tw-h-[400px] tw-items-center tw-justify-center"><div><h3 class="tw-typ-h2-subheading-a"></h3></div></div>'), ee = /* @__PURE__ */ v('<div class="tw-mb-1 tw-flex tw-min-h-[28px] tw-items-center tw-pt-2"></div>'), te = /* @__PURE__ */ v('<div class="tw-mt-auto tw-flex tw-flex-col tw-justify-center"><div class="tw-p-4"><figure><img><figcaption class="tw-my-4"><a class="full-unstyled-link tw-typ-h4-subtopic-2 after:!tw-hidden hover:!tw-no-underline"></a></figcaption></figure><form style="margin-bottom:20px" class="product-form" action="/cart/add" method="post"><input type="hidden" name="id" class="product-select"><input type="submit" class="tw-button tw-button-primary tw-block"></form><button class="remove-item-button tw-button tw-button-primary-dark"></button></div><section><div class="table"></div></section></div>'), ne = /* @__PURE__ */ v('<div class="tw-w-full tw-border-b-2 tw-p-4"><h4 class="label tw-invisible tw-font-bold"> </h4> </div>'), ae = /* @__PURE__ */ v('<div class="tw-grid-system tw-flex"><div class="tw-grid tw-w-full tw-grid-flow-col tw-grid-cols-[repeat(3,minmax(230px,_1fr))]  tw-overflow-x-auto [&amp;>div:first-child>section>div>div>h4]:tw-visible"></div></div>'), le = /* @__PURE__ */ v('<div class="tw-col-span-3 tw-flex tw-h-[400px] tw-items-center"><div><h1 class="tw-typ-h2-subheading-a"></h1><p class="tw-typ-h3-subtopic-1-a tw-mt-2"></p></div></div>'), re = (d, i) => {
  const r = sessionStorage.getItem(d), [l, c] = G(r ? JSON.parse(r) : i);
  return H(() => sessionStorage.setItem(d, JSON.stringify(l))), [l, c];
}, [q, se] = re("products", []), ie = async ({
  handle: d,
  view: i
}) => {
  try {
    return await (await fetch(`${window.Shopify.routes.root}products/${d}?view=${i}`)).json();
  } catch {
  }
}, oe = ({
  id: d
}) => {
  const [i] = L({
    handle: d,
    view: "price.json"
  }, ie);
  return (() => {
    const r = K.cloneNode(!0);
    return a(r, b(N, {
      keyed: !0,
      get when() {
        return i();
      },
      get fallback() {
        return (() => {
          const l = U.cloneNode(!0);
          return a(l, () => {
            var c;
            return (c = window.comparatorPage) == null ? void 0 : c.loadingText;
          }), l;
        })();
      },
      children: (l) => I((() => {
        const c = I(() => l.compare_at_price < l.money_price);
        return () => c() ? [(() => {
          const o = W.cloneNode(!0);
          return a(o, () => l.money_price), o;
        })(), " "] : [(() => {
          const o = X.cloneNode(!0);
          return a(o, () => l.compare_at_price), o;
        })(), (() => {
          const o = Y.cloneNode(!0);
          return o.firstChild, a(o, () => l.money_price, null), o;
        })()];
      })())
    })), r;
  })();
}, de = ({
  handle: d
}) => {
  const [i] = V(z, {
    handle: d
  }), r = () => {
    var e, n, h, s;
    return {
      sku: ((n = (e = i()) == null ? void 0 : e.product) == null ? void 0 : n.variants.nodes[0].sku) || "",
      title: ((s = (h = i()) == null ? void 0 : h.product) == null ? void 0 : s.title) || ""
    };
  }, l = (e) => {
    var s, $, g;
    const n = T((g = ($ = (s = i()) == null ? void 0 : s.product) == null ? void 0 : $.metafields.find((w) => (w == null ? void 0 : w.key) === "jp_relations")) == null ? void 0 : g.value, "relations");
    return n != null && n.success ? n.data.find((w) => w.name === e) : null;
  }, c = (e) => {
    var s, $, g, w, x;
    const n = T((g = ($ = (s = i()) == null ? void 0 : s.product) == null ? void 0 : $.metafields.find((f) => (f == null ? void 0 : f.key) === "jp_attributes")) == null ? void 0 : g.value, "p_attributes");
    return n != null && n.success ? ((x = (w = n.data) == null ? void 0 : w.find((f) => f.name === e)) == null ? void 0 : x.value) || "-" : null;
  }, o = (e) => {
    se(q.filter((n) => n.handle !== e));
  }, y = ["height", "width", "capacity", "profundidad", "weight", "product_material"];
  return b(N, {
    keyed: !0,
    get when() {
      return i();
    },
    get fallback() {
      return (() => {
        const e = Z.cloneNode(!0), n = e.firstChild, h = n.firstChild;
        return a(h, () => {
          var s;
          return (s = window.comparatorPage) == null ? void 0 : s.loadingText;
        }), e;
      })();
    },
    children: ({
      product: e
    }) => (() => {
      const n = te.cloneNode(!0), h = n.firstChild, s = h.firstChild, $ = s.firstChild, g = $.nextSibling, w = g.firstChild, x = s.nextSibling, f = x.firstChild, j = f.nextSibling, E = x.nextSibling, A = h.nextSibling, D = A.firstChild;
      return a(w, () => e == null ? void 0 : e.title), a(g, b(oe, {
        get id() {
          return (e == null ? void 0 : e.handle) || "";
        }
      }), null), a(g, b(N, {
        get when() {
          var t, u;
          return Number((u = (t = l("Color")) == null ? void 0 : t.values) == null ? void 0 : u.length) > 0;
        },
        get children() {
          const t = ee.cloneNode(!0);
          return a(t, b(Q, {
            filterBy: "color_hex",
            colorSelectorViewMode: "swatches",
            get data() {
              var u;
              return [...(u = l("Color")) == null ? void 0 : u.values.map((_) => ({
                title: _.name,
                sku: _.sku
              })), r()];
            },
            get currentProductData() {
              return r();
            }
          })), t;
        }
      }), null), E.$$click = () => o((e == null ? void 0 : e.handle) || ""), a(E, () => {
        var t;
        return (t = window.comparatorPage) == null ? void 0 : t.buttonRemoveText;
      }), a(D, b(M, {
        each: y,
        children: (t) => {
          const u = c(t);
          return (() => {
            const _ = ne.cloneNode(!0), p = _.firstChild, S = p.firstChild, k = p.nextSibling;
            return a(p, () => {
              var m;
              return (m = window.comparatorPage) == null ? void 0 : m.rows[t].title;
            }, S), a(p, () => {
              var m;
              return t !== "product_material" && ((m = window.comparatorPage) == null ? void 0 : m.rows[t].unit);
            }, null), a(_, u, k), a(_, () => {
              var m;
              return t !== "product_material" && u !== "-" && ((m = window.comparatorPage) == null ? void 0 : m.rows[t].unit);
            }, null), _;
          })();
        }
      })), P((t) => {
        var F;
        const u = (F = e == null ? void 0 : e.featuredImage) == null ? void 0 : F.url, _ = e == null ? void 0 : e.title, p = `/products/${e == null ? void 0 : e.handle}`, S = e == null ? void 0 : e.id, k = e == null ? void 0 : e.id, m = e == null ? void 0 : e.variants.nodes[0].title, R = !(e != null && e.availableForSale);
        return u !== t._v$ && C($, "src", t._v$ = u), _ !== t._v$2 && C($, "alt", t._v$2 = _), p !== t._v$3 && C(w, "href", t._v$3 = p), S !== t._v$4 && C(x, "data-productid", t._v$4 = S), k !== t._v$5 && C(f, "data-productid", t._v$5 = k), m !== t._v$6 && C(f, "data-variant-title", t._v$6 = m), R !== t._v$7 && (j.disabled = t._v$7 = R), t;
      }, {
        _v$: void 0,
        _v$2: void 0,
        _v$3: void 0,
        _v$4: void 0,
        _v$5: void 0,
        _v$6: void 0,
        _v$7: void 0
      }), P(() => f.value = e == null ? void 0 : e.variants.nodes[0].id), P(() => {
        var t;
        return j.value = (t = window.comparatorPage) == null ? void 0 : t.buttonAddToCartText;
      }), n;
    })()
  });
}, ce = () => (() => {
  const d = ae.cloneNode(!0), i = d.firstChild;
  return a(i, b(M, {
    each: q,
    get fallback() {
      return (() => {
        const r = le.cloneNode(!0), l = r.firstChild, c = l.firstChild, o = c.nextSibling;
        return a(c, () => {
          var y;
          return (y = window.comparatorPage) == null ? void 0 : y.titleEmptyComparator;
        }), a(o, () => {
          var y;
          return (y = window.comparatorPage) == null ? void 0 : y.descriptionEmptyComparator;
        }), r;
      })();
    },
    children: (r) => b(de, {
      get handle() {
        return r.handle;
      }
    })
  })), d;
})(), B = document.getElementById("comparator-page");
B && J(ce, B);
O(["click"]);
